import { render, staticRenderFns } from "./BesView.vue?vue&type=template&id=34f25b9f&"
import script from "./BesView.vue?vue&type=script&lang=js&"
export * from "./BesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports